/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vekn_Merge_Search_LabelInputs */



/**
* | output |
* | --- |
* | "Account to merge" |
*
* @param {Vekn_Merge_Search_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const vekn_merge_search_label = /** @type {((inputs?: Vekn_Merge_Search_LabelInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vekn_Merge_Search_LabelInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Compte à fusionner")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cuenta a fusionar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Conta para mesclar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Account da unire")
	return /** @type {LocalizedString} */ ("Account to merge")
});